import React from "react";
import { ChildrenProps } from "@hex-insights/core";
import { PermissionRequired, usePermissionCheck } from "@hex-insights/permissioning";
import { permissions } from "../../../../Utilities";

export type CreatePermissionRequiredProps = Partial<ChildrenProps>;

export function StudentNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	const hasPermission = useStudentNoteCreatePermissionCheck();

	if (!hasPermission) {
		return null;
	}

	return <React.Fragment>{children}</React.Fragment>;
}

const baseCreatePermissions = [permissions.StudentNote.Create.Admin, permissions.StudentNote.Create.Basic];

export function useStudentNoteCreatePermissionCheck() {
	return usePermissionCheck({ requiredPermissions: baseCreatePermissions, checkMethod: "or" });
}

const academicCreatePermissions = [
	permissions.StudentAcademicNote.Create.Admin,
	permissions.StudentAcademicNote.Create.Basic,
];

export function StudentAcademicNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={academicCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const attendanceCreatePermissions = [
	permissions.StudentAttendanceNote.Create.Admin,
	permissions.StudentAttendanceNote.Create.Basic,
];

export function StudentAttendanceNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={attendanceCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const behaviorCreatePermissions = [
	permissions.StudentBehaviorNote.Create.Admin,
	permissions.StudentBehaviorNote.Create.Basic,
];

export function StudentBehaviorNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={behaviorCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const generalCreatePermissions = [permissions.StudentNote.Create.Admin, permissions.StudentNote.Create.Basic];

export function StudentGeneralNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={generalCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const healthCreatePermissions = [
	permissions.StudentHealthNote.Create.Admin,
	permissions.StudentHealthNote.Create.Basic,
];

export function StudentHealthNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={healthCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const incidentCreatePermissions = [
	permissions.StudentIncidentNote.Create.Admin,
	permissions.StudentIncidentNote.Create.Basic,
];

export function StudentIncidentNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={incidentCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const injuryCreatePermissions = [
	permissions.StudentInjuryNote.Create.Admin,
	permissions.StudentInjuryNote.Create.Basic,
];

export function StudentInjuryNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={injuryCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const medicationCreatePermissions = [
	permissions.StudentMedicationNote.Create.Admin,
	permissions.StudentMedicationNote.Create.Basic,
];

export function StudentMedicationNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={medicationCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

const socialEmotionalCreatePermissions = [
	permissions.StudentSocialEmotionalNote.Create.Admin,
	permissions.StudentSocialEmotionalNote.Create.Basic,
];

export function StudentSocialEmotionalNoteCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={socialEmotionalCreatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}
